import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import SocialMediaInfoCard from "./SocialMediaInfoCard";
import axios from "axios";
import { IconWrapper } from "../../Components/StyledComponents/StyledComponents";
import environmentVariables from "../../config/environmentVariables";

const Root = styled.div`
  margin-top: ${(p) => p.theme.spacing.lg};
  @media (max-width: ${(p) => p.theme.screen.md}) {
    margin-top: 20px;
  }
`;
const Icon = styled.img`
  width: 26px;
  height: 26px;
  aspect-ratio: auto 1/1;
`;

const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  position: relative;
  display: flex;
  margin-bottom: ${(p) => p.theme.spacing.xxl};
  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: 90%;
  }
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    width: 100%;
    padding: ${(p) => p.theme.spacing.sm};
    margin-bottom: ${(p) => p.theme.spacing.xs};
  }
`;
const Heading = styled.div`
  font-family: ${(p) => p.theme.font.family.SweraDemo};
  display: flex;
  color: #e3e3e3;
  font-size: 24px;
  font-weight: ${(p) => p.theme.font.weight.bolder};
  margin-bottom: ${(p) => p.theme.spacing.md};
  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 20px;
  }
  @media (max-width: 1024px) {
    font-size: 24px;
    margin-bottom: 20px;
  }
`;

const InfoCardWrapper = styled.div`
  width: 74%;
  position: relative;
  z-index: 20 !important;
  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: 100%;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 26%;
  z-index: 10;
  @media (max-width: ${(p) => p.theme.screen.md}) {
    display: none;
  }
`;
const BgcolorImage = styled.img`
  width: 330px;
  z-index: 1;
  position: absolute;
  right: -30px;
  @media (max-width: ${(p) => p.theme.screen.md}) {
    right: 0;
  }
  @media (min-width: 1600px) {
    width: 330px;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${(p) => p.theme.spacing.sm};

  @media (max-width: ${(p) => p.theme.screen.xs}) {
    flex-direction: column;
    margin-bottom: ${(p) => p.theme.spacing.none};
  }
`;
const animate = keyframes`
  0%{
    transform:translateY(0);
  }
  25%{
    transform:translateY(10px);
  }
  50%{
    transform:translateY(-10px);
  }
  100%{
    transform:translateY(0);
  }
`;
const Image = styled.img`
  width: 200px;
  position: absolute;
  top: 25px;
  left: 60px;
  z-index: 15;
  animation-timing-function: ease-in;
  animation: ${animate} 1.9s infinite linear;
`;

const SocialMediaInfoSection = () => {
  const [telegram, setTelegram] = useState(0);
  const [discord, setDiscord] = useState(0);
  const [instagram, setInstagram] = useState(1197);

  const formatNumberWithCommas = (number) => {
    return number.toLocaleString();
  };

  const getSocialFollowers = () => {
    axios
      .get(
        `https://api.telegram.org/bot6230343154:AAFovR1TPSJPOkJEC0eGTS3bMtYY0j_9lHA/getChatMembersCount?chat_id=@MetaSpace_Metaverse`
      )
      .then((res) => {
        const formattedTelegramCount = formatNumberWithCommas(res.data.result);
        setTelegram(formattedTelegramCount);
        // setTelegram(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getDiscordFollowers = () => {
    axios
      .get(
        `https://discord.com/api/v9/invites/u4jWrHV3XC?with_counts=true&with_expiration=true`
      )
      .then((res) => {
        const formattedDiscordCount = formatNumberWithCommas(
          res.data.approximate_member_count
        );
        setDiscord(formattedDiscordCount);
        // setDiscord(res.data.approximate_member_count);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getInstagramFollowers = () => {
    axios
      .get(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/socialfollowers`
      )
      .then((response) => {
        console.log("Instagramfollowers", response.data.instaFollowers);
        setInstagram(response.data.instaFollowers || 1197);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getSocialFollowers();
    getDiscordFollowers();
    getInstagramFollowers();
  });

  return (
    <Root>
      <Container>
        <InfoCardWrapper>
          <Heading>
            <IconWrapper>
              <Icon src={`${environmentVariables?.cdnUrl}squadicon.png`} />
            </IconWrapper>{" "}
            Metaspace Squad
          </Heading>
          <CardWrapper>
            <SocialMediaInfoCard
              text="Total supply of $MLD"
              number="2,000,000,000"
              Icon={`${environmentVariables?.cdnUrl}Total_supply.png`}
              // color1="color1"
            />
            <SocialMediaInfoCard
              text="Instagram Followers"
              number={instagram}
              Icon={`${environmentVariables?.cdnUrl}InstagramIcon.png`}
              // color2="color2"
            />
          </CardWrapper>
          <CardWrapper>
            <SocialMediaInfoCard
              text="Telegram Members"
              number={telegram}
              Icon={`${environmentVariables?.cdnUrl}Telegram.png`}
              // color3="color3"
            />
            <SocialMediaInfoCard
              text="Discord Members"
              number={discord}
              Icon={`${environmentVariables?.cdnUrl}discordlogo.png`}
              // color4="color4"
            />
          </CardWrapper>
        </InfoCardWrapper>
        <ImageWrapper>
          <Image src={`${environmentVariables?.cdnUrl}mia.png`} />
          <BgcolorImage src={`${environmentVariables?.cdnUrl}mia_bg.png`} />
        </ImageWrapper>
      </Container>
    </Root>
  );
};

export default SocialMediaInfoSection;
